import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import type { Routes } from "@angular/router";

const redirectLoggedInToDashboard = () => redirectLoggedInTo(["dashboard"]);
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);

export const appRoutes: Routes = [
    // Main redirect
    { path: "", redirectTo: "login", pathMatch: "full" },

    // App components
    {
        path: "dashboard",
        loadComponent: () => import("./features/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        loadChildren: () => import("./features/dashboard/dashboard.routes"),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
    },

    {
        path: "login",
        loadComponent: () => import("./features/login/login.component").then((m) => m.LoginComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectLoggedInToDashboard }
    },

    { path: "**", redirectTo: "dashboard" }
];
